import { useEffect, useRef } from 'react';

const guards = new Set<() => boolean>();
export function mayLeave() { return [...guards].every((guard) => guard()); }

export function useLeaveFence(blocked: boolean | (() => boolean), explain: () => void) {
  const current = useRef({ blocked, explain });
  current.current = { blocked, explain };
  useEffect(() => {
    const isBlocked = () => typeof current.current.blocked === 'function' ? current.current.blocked() : current.current.blocked;
    const guard = () => { if (!isBlocked()) return true; current.current.explain(); return false; };
    const beforeUnload = (event: BeforeUnloadEvent) => { if (isBlocked()) { event.preventDefault(); event.returnValue = ''; } };
    guards.add(guard); window.addEventListener('beforeunload', beforeUnload);
    return () => { guards.delete(guard); window.removeEventListener('beforeunload', beforeUnload); };
  }, []);
  return () => { current.current.blocked = false; };
}
